<template>
  <div>
    <a-modal 
      :visible.sync="visible"
      :width="'90%'"
      @cancel="visible=false"
      :maskClosable="false"
      :destroyOnClose="true"
      :title="unit.unitName" onOk="handleOk" :footer="null">
      
      <!-- <template slot="footer">
        <a-button key="back" @click="handleCancel">关闭</a-button>
      </template> -->
            
      <a-row :gutter="24">
        <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
            <div v-if="videoUrl" class="video-area">
              <video oncontextmenu="return false;" controlsList='nodownload noremote footbar' :src="videoUrl" controls="true"
              @canplay="handleVideoInit"
              @play="handleVideoPlay"
              @timeupdate="handleVideoUpdate"
              @pause="handleVideoPause"
              @ended="handleVideoEnded"
              ></video>
            </div>
            <div v-if="mediaContent" v-html="mediaContent" class="video-area">
            </div>
        </a-col>
        <a-divider v-if="_isMobile()"/>
        <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <div class="unit-list">
              <a-timeline>
                <a-timeline-item color="blue" v-for="(media,index) in mediaList" :key="media.id">
                  <a-icon v-if="media.mediaType==5" slot="dot" type="edit" style="font-size: 16px;" />
                  <a-icon v-if="media.mediaType==1" slot="dot" type="play-circle" style="font-size: 16px;" />
                  <a-icon v-if="media.mediaType==3" slot="dot" type="snippets" style="font-size: 16px;" />
                  <a-button block @click="changeMedia(media, index)" :type="currentMediaIndex==index?'primary':'default'">
                    {{media.mediaName}}<a-icon type="right"/>
                  </a-button>
                </a-timeline-item>
            </a-timeline>
            <a-card v-if="unit.unitIntro" size="small" title="课程说明">
              <div v-html="unit.unitIntro ? unit.unitIntro.replace(/\n/g,'<br>') : ''"></div>
            </a-card>
            </div>
        </a-col>
      </a-row>

      <div v-if="false">
        <a-divider>本节课作业</a-divider>
        <a-row :gutter="24">
          <a-col :span="16">
            <a-card size="small" title="课程说明">
              <div v-html="unit.unitIntro ? unit.unitIntro.replace(/\n/g,'<br>') : ''"></div>
            </a-card>
          </a-col>
          <a-col :span="8">
            <a-collapse defaultActiveKey="0" :bordered="false">
              <template v-slot:expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel :header="'课后作业'"  :style="customStyle">
                <a target="_blank" :href="'/scratch/index.html?unitId='+unit.id"><a-icon type="edit" />{{unit.unitName}} 去做作业</a>
              </a-collapse-panel>
              <a-collapse-panel :header="'课程资料'"  :style="customStyle">
                <a target="_blank" :href="getQiniuFile(unit.coursePpt)"><a-icon type="edit" />{{unit.unitName}} 查看PPT</a>
              </a-collapse-panel>
            </a-collapse>
          </a-col>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>
<script>
// import '@/components/jeecg/JModal'
import { getAction } from '@/api/manage'
import {mixinDevice} from '@/utils/mixin.js'
import { getQiniuUrl,getQiniuFile } from '@/utils/qiniu.js'
export default {
  name: 'UnitViewModal',
  mixins: [mixinDevice],
  data() {
    return {
      customStyle:
          'background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden',
      visible: false,
      unit: {},
      videoUrl: '',
      mediaList: [],
      url:{
        unitMedia: '/teaching/teachingCourseUnit/unitMedia',
        studyLog: '/teaching/teachingStudyLog/study',
        unitStudyLog: '/teaching/teachingStudyLog/getUnitStudyLog'
      },
      mediaContent: '',
      currentMedia: {},
      currentMediaIndex: 0,
      lastPlayTime: 0, //上次视频观看进度
      cacheDuration: 0, //等待提交的进度
    }
  },
  mounted() {
    // contextmenu 禁用右键菜单
    document.addEventListener('contextmenu',function(e){
        e.preventDefault();
    })
    // //禁止复制  selectstart
    // document.addEventListener('selectstart',function(e){
    //     e.preventDefault();
    // })
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
    handleCancel(e) {
      this.visible = false
      this.unit = {}
      this.videoUrl = ''
      this.mediaList = []
    },
    view(unit){
      console.log(unit);
      this.visible = true
      this.currentMediaIndex = 0
      this.unit = unit;
      this.getCourseMedia(unit.id);
      this.getUnitStudyLog()
      
    },
    getCourseMedia(unitId){
      getAction(this.url.unitMedia, {id: unitId}).then(res=>{
        if(res.success){
          this.mediaList = res.result
          for(let i=0; i<this.mediaList.length; i++){
            let item = this.mediaList[i]
            if([1,7].includes(item.mediaType)){
              this.changeMedia(item, i)
              break
            }
          }
        }else{
          this.$message.error(res.message)
        }
      }).catch(e=>{
        let data = e.response.data
        if (data.message.includes("Token失效")) {
          this.$message.error("未登录")
        }
      })
    },
    changeMedia(media, index){
      this.currentMedia = media
      this.currentMediaIndex = index
      switch(media.mediaType){
        case 1:
          //切换视频
          this.mediaContent = ''
          this.videoUrl = media.mediaPath_url
          break;
        case 3:
        case 5:
          this.handleViewCode(media)
          break;
        case 6:
          window.open('https://view.officeapps.live.com/op/embed.aspx?src=' + media.mediaPath_url)
          break;
        case 7: //富文本
          this.videoUrl = ''
          this.mediaContent = media.mediaContent
          this.studyLog(0,0,true)
          break;
        case 8: //OJ
          window.open('/onlinecode/index.html?questionId=' + media.questionId)
          break
        default:
          window.open(media.mediaPath_url)
      }
    },
    handleVideoInit(){
      console.log("video init");
      this.studyLog(0, 0, false)
    },
    handleVideoPlay(){
      console.log("play");
    },
    handleVideoPause(){
      console.log("pause");
    },
    handleVideoEnded(e){
      console.log("ended");
      let duration = e.target.duration
      this.currentMedia.finished = true
      this.studyLog(parseInt(duration), parseInt(this.cacheDuration), true)
    },
    handleVideoUpdate(e){
      let rate = 10 //日志记录频率
      let currentTime = e.target.currentTime
      let duration = e.target.duration
      this.cacheDuration += currentTime - this.lastPlayTime
      this.lastPlayTime = currentTime
      //播放10秒记录日志
      if(this.cacheDuration > rate){
          studyLog(parseInt(duration), parseInt(this.cacheDuration), false)
          this.cacheDuration = 0
      }
    },
    //记录学习日志
    studyLog(videoTime,duration,finished) {
      getAction(this.url.studyLog, {
        mediaId:this.currentMedia.id,
        mediaType:this.currentMedia.mediaType,
        unitId:this.unit.id,
        courseId:this.unit.courseId,
        videoTime,duration,finished}).then(res=>{

      })
    },
    getUnitStudyLog(){
      getAction(this.url.unitStudyLog, {courseId: this.unit.courseId, unitId: this.unit.id})
    },
    handleViewCode (media) {
      switch (media.codeType) {
        case 1:
          window.open('/scratch3/index.html?scene=twl&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        case 2:
          window.open('/scratch3/index.html?scene=twl&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        case 3:
          return window.open('/scratchjr/editor.html?mode=edit&filepath=' + media.mediaPath_url)
          break
        case 4:
          return window.open('/onlinecode/index.html?lang=turtle&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        case 5:
          return window.open('/onlinecode/index.html?lang=python&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        case 6:
          return window.open('/onlinecode/index.html?lang=c&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        case 7:
          return window.open('/onlinecode/index.html?lang=cpp&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        case 8:
          return window.open('/onlinecode/index.html?lang=java&unitId='+this.unit.id + '&mediaId=' + media.id + '&workName=' + media.mediaName)
          break
        default:
          window.open(this.getQiniuFile(media.mediaPath_url))
      }
  },
  },
}
</script>
<style lang="less" scoped>
.video-area{
  max-height: 700px;
  overflow: auto;
  video{
    width: 100%;
    height: 700px;
    // min-height: 500px;
  }
}
.unit-list{
  vertical-align:top;
  padding: 10px;
  margin: 0 20px;
  overflow-y: auto;
}
</style>
